export class Beneficiary {
  Address: string;
  BeneficiaryId: string;
  ConciseLocation: string;
  Longtitude: string;
  RegisterUnixTime: string;
  Latitude: string;
  ButtonId: string;
}
